<div class="component-container" *ngIf="showEnergyProducerDataSection()">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align section-heading text-uppercase">
      <div class="ui-g-12">
        <app-section-header
          [title]="'grid-comp.energy-producer-title' | translate"
          [tooltip]="'tooltips.technician-form.energy-producer' | translate"></app-section-header>
      </div>
      <div class="section-buttons">
        <lock-unlock-buttons
          [showLockButton]="isDetailsView"
          [showUnlockButton]="isDetailsView"
          [isLocked]="getSectionLocked()"
          [areButtonsDisabled]="!(isModeratorRole() && editabilityBasedOnProcessStatus.internalRoles)"
          (lockButtonClickedEvent)="lockSection()"
          (unLockButtonClickedEvent)="unlockSection()"></lock-unlock-buttons>
        <i
          *ngIf="isDetailsView"
          class="pi pi-comment"
          [ngClass]="isCommentVisible || getSectionComment() ? 'lock-icon-style' : 'unlock-icon-style'"
          [pTooltip]="showCommentTooltip() ? ('comment-section.comment-tooltip' | translate) : null"
          [tooltipPosition]="showCommentTooltip() ? 'bottom' : null"
          (click)="showComment()"></i>
      </div>
    </div>
  </div>
  <section-comment
    [isCommentTextInputVisible]="isModeratorRole() && (isCommentVisible || getSectionComment())"
    [isCommentTextVisible]="!isModeratorRole()"
    [isCommentSaveVisible]="!getSectionComment()"
    [isCommentDeleteButtonDisabled]="!editabilityBasedOnProcessStatus.internalRoles"
    [comment]="getSectionComment()"
    (saveCommentEvent)="updateComment($event)"
    (deleteCommentEvent)="deleteComment()"
    (changeTextEvent)="changeCommentText.emit($event)"></section-comment>
  <div [ngClass]="getSectionLocked() !== true || !applicationId ? '' : 'disable-section'" class="section-wrapper margin-align">
    <div class="section-column">
      <div class="section-field">
        <label class="ui-g-5 required">
          {{ 'grid-comp.total-power-generators' | translate }}
        </label>
        <p-inputNumber
          class="form-control"
          [(ngModel)]="technicalData.total_power_generators"
          (ngModelChange)="calculatePowerDifference()"
          name="total_power_generators"
          #total_power_generators="ngModel"
          mode="decimal"
          locale="de-DE"
          [minFractionDigits]="0"
          (keydown)="detectDecimalSeparator($event)"
          [maxFractionDigits]="3"
          required
          [disabled]="isSectionDisabled"></p-inputNumber>
        <label class="ml-2">kW</label>
      </div>
      <div *ngIf="generatorsPowerNotEqual" class="section-field">
        <i class="pi pi-exclamation-circle"></i>
        <span>{{ 'grid-comp.generators-power-warning' | translate }}</span>
      </div>
    </div>
    <div *ngFor="let generator of technicalData.generators; index as i" class="top-bottom-margin bottom-border">
      <app-eproducer-unit-form-element
        [energyUnit]="generator"
        [index]="i"
        [isDetailsView]="isDetailsView"
        [isDisabled]="isSectionDisabled"
        [documents]="generator.documents"
        [type]="UI_COLLECTION_TYPES.Generator"
        (removeElementEvent)="removeGenerator($event)"
        (maxPowerChangeEvent)="calculatePowerDifference()"
        (clearFileEvent)="clearFile($event)"></app-eproducer-unit-form-element>
    </div>

    <div class="section-field" [ngClass]="isSectionDisabled ? 'disable-section' : ''">
      <i (click)="addGenerator()" class="pi pi-plus plus-icon margin-zero" data-testId="add-generator-btn"></i>
      <label class="field-label">
        {{ 'grid-comp.add-generator' | translate }}
      </label>
    </div>
  </div>
</div>
